/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_HeightInputs */

const cs_builder_prop_height = /** @type {(inputs: Builder_Prop_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výška (pt)`)
};

const en_builder_prop_height = /** @type {(inputs: Builder_Prop_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Height (pt)`)
};

/**
* | output |
* | --- |
* | "Height (pt)" |
*
* @param {Builder_Prop_HeightInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_height = /** @type {((inputs?: Builder_Prop_HeightInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_HeightInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_height(inputs)
	return cs_builder_prop_height(inputs)
});